<template>
    <router-link tag="li" class="menu_btn" :to="{name:menu.route}" exact>
        {{menu.name}}
    </router-link>
</template>

<script>
    export default {
        name: "layout-menu-item",

        props:{
            menu:Object
        }
    }
</script>

<style scoped lang="less">
    @import "../../../assets/css/style";
    .menu_btn{
        display: block;
        float: left;
        width: 90px;
        height: inherit;
        text-align: center;
        line-height: inherit;
        color: @menu-color;
        user-select: none;
        cursor: pointer;
        background-color: @menu-background-color;
        &:hover{
            .router-link-active()
        }
    }
    .router-link-active{
        color: @menu-active-color;
        background-color: @menu-background-active-color;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/elements/LayoutMenuItem.vue